<div class="container-fluid" *ngIf="productSearchData; else noReviews ">

  <div class="row d-flex">
    <div class="col-lg-12" style="display: block;">
      <!-- <div *ngIf="loadingService.isLoading | async" class="loader-container">
          <mat-spinner style="top: 50%; left: 50%"></mat-spinner>
        </div> -->
      <!-- [hidden]="getdata()" -->
      <div>
        <div class="card mb-4" style="position: relative; background-color: white;">

          <div class="row card-body text-start">

            <div class="col-md-5">
              <swiper-container class="mySwiper" style="--swiper-navigation-color: gray" navigation="true"
                pagination="true" loop="false" thumbs-swiper=".mySwiper2">
                <swiper-slide *ngFor="let images of productSearchData.extra_images">
                  <img [src]="images" class="d-block w-100" alt="..." />
                </swiper-slide>

              </swiper-container>

              <swiper-container class="mySwiper2" space-between="10" slides-per-view="4" free-mode="true">
                <swiper-slide *ngFor="let images of productSearchData.extra_images">
                  <img [src]="images" class="d-block w-100" alt="..." />
                </swiper-slide>
              </swiper-container>
            </div>

            <div class="col-md-7">
              <h6>
                {{ productSearchData.Product_name }}
              </h6>

              <p><strong>Product SKU Code: </strong> {{ productSearchData.Product_features.ASIN }}</p>
              <div class="row">
                <div class="d-flex justify-content-start align-items flex-wrap">
                  <p>
                    <strong>Rating: </strong>{{productSearchData.Rating_value }}
                  </p>
                  <app-star-rating style="display: inline-block" [stars]="productSearchData.Rating_value"
                    [size]="1"></app-star-rating>
                  <p>|</p>
                  <p><strong>RatingCount: </strong>{{productSearchData.Rating_count }}</p>
                </div>
              </div>

              <div class="row">
                <div class="d-flex flex-wrap">
                  <div class="pricing-info">
                    <p class="mrp text-decoration-line-through"><strong>M.R.P: </strong>{{ productSearchData.MRP |
                      currency : currency }}</p>
                  </div>
                  <div class="pricing-info">
                    <p class="sp">
                      <strong>Selling price:</strong> {{ productSearchData.Selling_Price | currency : currency }}
                    </p>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="d-flex">
                  <div class="product-url">
                    <a style="text-decoration: none; color: white;" href={{productSearchData.Product_url}}
                      target="_blank" class="amazon-link">View on Amazon</a>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="d-flex justify-content-start align-items flex-wrap">
                  <button style="margin: 5px" class="btn btn-primary" type="submit"
                    (click)="handleSpecificationAction()">
                    Specification
                  </button>
                  <button style="margin: 5px" class="btn btn-primary" type="submit"
                    (click)="handleBulletPointsAction()">
                    Bullet Points
                  </button>

                  <button style="margin: 5px" class="btn btn-primary" type="submit" (click)="handleImpInfoAction()">
                    Important Information
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="d-flex flex-wrap ">
                  <P style="font-size: 1.2rem;"><b>Brand: </b> {{productSearchData.Product_features.Brand }}</P>
                  <p style="font-size: 1.2rem;"><b>Availability: </b> <span
                      [ngStyle]="{ 'color': productSearchData.Availablity === 'Instock' ? 'green' : 'red' }">{{productSearchData.Availablity
                      }}</span> </p>
                  <!-- <P><b>Condition: </b><span>{{productSearchData.}}</span></P> -->
                  <P><b>Review Count: </b> {{productSearchData.Review_count }}</P>
                  <P><b>Bought: </b> {{productSearchData.bought }}</P>
                  <P><b>Seller: </b> {{productSearchData.reseller_name }}</P>
                </div>
              </div>
            </div>

            <div class="col-md-12">

              <p><b>Description: </b>{{productSearchData.Description }}</p>
              <div class="row">
                <div class="d-flex justify-content-start align-items flex-wrap">
                  <button class="btn btn-primary dropdown-toggle px-2 py-0 m-1" style="color: white;" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    Reviews
                  </button>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" (click)="handleReviewListAction()">View Reviews</a></li>
                    <li><a class="dropdown-item">Reviews analysis</a></li>
                  </ul>

                  <button type="submit" (click)="saveSearchData()" [ngClass]="{'button--loading': isLoading}"
                    [disabled]="isLoading"
                    class="btn btn-primary  button--loading d-flex justify-content-center align-items-center px-2 py-0 m-1">
                    <span class="button--text"><mat-icon style="font-size: 15px;"
                        class="d-flex justify-content-center align-items-center" fontIcon="upload"></mat-icon></span>
                    <span class="button--text" style="text-align: center;">Save</span>
                  </button>
                </div>

                <div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noReviews>
  <div class="d-flex justify-content-center align-items-center">
    <p>No Data Available</p>
  </div>
</ng-template>